import { Form } from '../../services/form';
import { NotificationService } from '../../notification/swal/notification.service';
import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { MaskHelper } from '../../helpers/mask';
import { LoginModel, RegisterModel } from '../../models/login.model';
import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';
import { CPFModel } from '../input/rules/implementations/cpf.model';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.less']
})
export class RegisterComponent extends Form {

  user: RegisterModel = new RegisterModel();
  isTermAccepted = false;
  isBrazilian = true;

  constructor(private authService: AuthService, private router: Router, private notificationService: NotificationService) {
    super();
  }

  switchTermAccepted() {
    this.isTermAccepted = !this.isTermAccepted;
  }

  switchIsBrazilian() {
    this.isBrazilian = !this.isBrazilian;

    if (this.isBrazilian) {
      this.user.cpfInputModel = new InputModel(true, false, 'tel', 'CPF', [new RequiredModel(), new CPFModel()], new CPFModel());
    } else {
      this.user.cpfInputModel = new InputModel(true, false, 'tel', 'Passaporte / Documento', [new RequiredModel()], null, 11);
    }
  }

  private login(_user: LoginModel) {
    this.authService.signIn(_user)
      .then(() => {
        this.router.navigate(['general/home']);
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private registerValidFields() {
    this.user = MaskHelper.removeUserMask(this.user);
    this.authService.register(this.user)
      .then(() => {
        const login = new LoginModel();
        login.username = this.user.email;
        login.password = this.user.senha;
        this.login(login);
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  register() {
    this.user.ehBrasileiro = this.isBrazilian;
    if (this.getFormStatus()) {
      if (this.user.senha === this.user.confirmarSenha) {
        this.registerValidFields();
      } else {
        this.notificationService.showAlertNotification('As senhas estão diferentes!');
      }
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

  goBack(): void {
    this.router.navigate(['login']);
  }

  terms(): void {
    this.router.navigate(['termsAndConditions']);
  }

  showTerms() {
    this.notificationService.showSuccessNotification('Bem-vindo a Meep');
  }

}





// WEBPACK FOOTER //
// /usr/src/app/src/app/components/register/register.component.ts